import { useState, useEffect } from 'react';
import { Card, Accordion, Spinner, Alert, Badge } from 'react-bootstrap';
import { FaHistory } from 'react-icons/fa';
import laporanService from '../services/laporanService';
import './RiwayatLaporan.css';

const RiwayatLaporan = () => {
    const [laporanList, setLaporanList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Fungsi pencetak ID jika pelapor langsung mengunjungi halaman ini tanpa buat laporan dulu
    const getOrCreateSessionId = () => {
        let id = localStorage.getItem("sipuma_session_id");
        if (!id) {
            id = 'session-' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            localStorage.setItem("sipuma_session_id", id);
        }
        return id;
    };

    useEffect(() => {
        const idSesi = getOrCreateSessionId();

        laporanService.getLaporanBySessionId(idSesi)
            .then(response => {
                // Pastikan format array agar tidak error memutar loading
                const dataArray = Array.isArray(response.data) ? response.data : [];
                setLaporanList(dataArray.reverse());
                setLoading(false);
            })
            .catch((err) => {
                console.error("Gagal load riwayat:", err);
                setError("Gagal memuat histori pelaporan browser Anda.");
                setLoading(false);
            });
    }, []);

    const getStatusBadge = (status) => {
        if (status === 'BARU') return <Badge bg="warning" className="text-dark">Baru</Badge>;
        if (status === 'DIPROSES') return <Badge bg="primary">Sedang Diproses</Badge>;
        return <Badge bg="success">Selesai</Badge>;
    };

    return (
        <Card className="border-0 shadow-sm rounded-3">
            <Card.Header className="bg-white py-3 border-bottom">
                <h5 className="mb-0 fw-bold text-dark"><FaHistory className="me-2 text-primary" /> Tracking Pengaduan Saya</h5>
            </Card.Header>
            <Card.Body>
                {loading && <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div>}
                {error && <Alert variant="danger">{error}</Alert>}
                
                {!loading && !error && (
                    <Accordion defaultActiveKey="0">
                        {laporanList.length > 0 ? laporanList.map((item, index) => (
                            <Accordion.Item eventKey={index.toString()} key={item.id}>
                                <Accordion.Header>
                                    <div className="d-flex justify-content-between w-100 me-3 align-items-center">
                                        <div>
                                            <span className="fw-bold text-primary me-2">{item.nomorTiket}</span>
                                            <small className="text-muted">({item.kategoriLaporan})</small>
                                        </div>
                                        <div>{getStatusBadge(item.status)}</div>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="detail-section">
                                        <h6>Kronologi Aduan:</h6>
                                        <p className="bg-light p-3 rounded">{item.deskripsiLaporan}</p>
                                    </div>
                                    {item.feedbackDeskripsi && (
                                        <div className="detail-section mt-3 border-top pt-3">
                                            <h6 className="text-success">Respon Tindak Lanjut Instansi:</h6>
                                            <p className="p-3 rounded" style={{ backgroundColor: '#f0fff4', borderLeft: '4px solid #198754' }}>
                                                {item.feedbackDeskripsi}
                                            </p>
                                        </div>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        )) : (
                            <Alert variant="info" className="text-center my-3">
                                Tidak ada rekaman pengaduan yang dikirim dari browser ini. Keamanan privasi Anda terjamin.
                            </Alert>
                        )}
                    </Accordion>
                )}
            </Card.Body>
        </Card>
    );
};

export default RiwayatLaporan;